// extracted by css-extract-rspack-plugin
var _1 = "M0zDXFWYwy803rJx";
var _2 = "W73Vi4EzDwgwsjTo";
var _3 = "y6XypwGp7oDCiwhP";
var _4 = "PjLXTlaTyK8Rw_Kt";
export { _1 as "imageWithRatio", _2 as "imageWrapper", _3 as "imageWrapperBlock", _4 as "imageWrapperError" }
// extracted by css-extract-rspack-plugin
var _1 = "M0zDXFWYwy803rJx";
var _2 = "W73Vi4EzDwgwsjTo";
var _3 = "y6XypwGp7oDCiwhP";
var _4 = "PjLXTlaTyK8Rw_Kt";
export { _1 as "imageWithRatio", _2 as "imageWrapper", _3 as "imageWrapperBlock", _4 as "imageWrapperError" }
